import type { PossiblePayloads } from "@/App/composables/types/PossibleCasePayloads";
import { HospitalCaseAction } from "@/Pages/Cases/CaseAction";
import type { MihFormPayload } from "@/Pages/Cases/components/Forms/Mih/stores/types/mih";
import type { CaseFormUIFields } from "@/Pages/Cases/components/Forms/common/CaseFormUIFields";

type CreateCaseAction = { payload: PossiblePayloads | CaseFormUIFields };

export const isCaseFormPayloadWithMih = (payload: PossiblePayloads | CaseFormUIFields): payload is MihFormPayload => {
  return "mih" in payload;
};

export const getCreateCaseAction = ({ payload }: CreateCaseAction): HospitalCaseAction => {
  if ("ift" in payload) {
    return HospitalCaseAction.createIftCase;
  }

  if (isCaseFormPayloadWithMih(payload) && payload.mih) {
    return HospitalCaseAction.createMihCase;
  }

  return HospitalCaseAction.createCase;
};
